/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_rd_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste a list and remove duplicate lines instantly. Keep the original order or sort alphabetically, with options to ignore case, trim, and drop blank lines.`)
};

const es_rd_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pega una lista y elimina líneas duplicadas al instante. Mantén el orden original u ordena alfabéticamente, con opciones para ignorar mayúsculas, recortar y eliminar líneas en blanco.`)
};

const de_rd_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fügen Sie eine Liste ein und entfernen Sie doppelte Zeilen sofort. Behalten Sie die ursprüngliche Reihenfolge bei oder sortieren Sie alphabetisch, mit Optionen zum Ignorieren der Groß-/Kleinschreibung, Trimmen und Entfernen leerer Zeilen.`)
};

const nl_rd_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plak een lijst en verwijder onmiddellijk dubbele regels. Behoud de oorspronkelijke volgorde of sorteer alfabetisch, met opties om hoofdlettergevoeligheid te negeren, trim en lege regels te verwijderen.`)
};

const fr_rd_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collez une liste et supprimez les lignes en doublon instantanément. Conservez l'ordre d'origine ou triez alphabétiquement, avec des options pour ignorer la casse, supprimer les espaces et supprimer les lignes vides.`)
};

const it_rd_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incolla un elenco e rimuovi istantaneamente le righe duplicate. Mantieni l'ordine originale o ordina alfabeticamente, con opzioni per ignorare maiuscole/minuscole, rimuovere spazi e eliminare righe vuote.`)
};

const pt_br2_rd_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole uma lista e remova linhas duplicadas instantaneamente. Mantenha a ordem original ou classifique alfabeticamente, com opções para ignorar maiúsculas, aparar e remover linhas em branco.`)
};

const pt_rd_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole uma lista e remova linhas duplicadas instantaneamente. Mantenha a ordem original ou ordene alfabeticamente, com opções para ignorar maiúsculas, aparar e eliminar linhas em branco.`)
};

const ja_rd_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リストをペーストして重複行を直ちに削除します。元の順序を保持またはアルファベット順にソート、大文字小文字を無視、トリム、空白行を削除するオプション付きです。`)
};

const zh_rd_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`粘贴一份列表，立即去除重复行。保留原始顺序或按字母排序，并可选择忽略大小写、去除首尾空格以及删除空行。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const rd_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.rd_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("rd_intro", locale)
	if (locale === "en") return en_rd_intro(inputs)
	if (locale === "es") return es_rd_intro(inputs)
	if (locale === "de") return de_rd_intro(inputs)
	if (locale === "nl") return nl_rd_intro(inputs)
	if (locale === "fr") return fr_rd_intro(inputs)
	if (locale === "it") return it_rd_intro(inputs)
	if (locale === "pt-BR") return pt_br2_rd_intro(inputs)
	if (locale === "pt") return pt_rd_intro(inputs)
	if (locale === "ja") return ja_rd_intro(inputs)
	return zh_rd_intro(inputs)
};